import { Injectable } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { parseSapDate } from 'src/app/helpers/date-helper';
import { IAdapter } from 'src/app/models';
import { Connector } from 'src/app/models/domain';
import { YPMCONNECTORVCDSYPMCONNECTORVType } from 'src/generated-clients/connector';

@Injectable({
  providedIn: 'root',
})
export class ConnectorAdapter implements IAdapter<Connector, YPMCONNECTORVCDSYPMCONNECTORVType> {
  public adaptToDomain(item: YPMCONNECTORVCDSYPMCONNECTORVType): Connector {
    return new Connector(
      uniqueId(), // connector lacks a good unique id, so we generate one
      item.materialNumber ?? '',
      item.topMainGroupId ?? '',
      item.topConnector ?? '',
      item.mainConnector ?? '',
      item.subConnector ?? '',
      item.createdBy ?? '',
      parseSapDate(item.createdOn) ?? undefined
    );
  }
}
